import { render } from "./CampaignsManagementDetailsGroup.vue?vue&type=template&id=b271a344&scoped=true&ts=true"
import script from "./CampaignsManagementDetailsGroup.vue?vue&type=script&lang=ts"
export * from "./CampaignsManagementDetailsGroup.vue?vue&type=script&lang=ts"

import "./CampaignsManagementDetailsGroup.vue?vue&type=style&index=0&id=b271a344&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b271a344"]])

export default __exports__